module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "cr"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Copyright © 2013 by Ken Francis")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN 9781625171023"), _c('br'), _vm._v("\nJust Write/5150 Media Publishing"), _c('br'), _vm._v("\n19202 Moorshine Place")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Cerritos, CA 90703")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.justwritepublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.justwritepublishing.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be80117","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/38_cr.vue
// module id = 60
// module chunks = 0